module.exports = __webpack_public_path__ + "static/media/sendAnnouncementsIcon.c898ef1f.svg";